import * as React from 'react'
import '../../styles/pages.css'
import { Box, Button } from '@mui/material'
import { PaginatedResourceList } from './resourceList/PaginatedResourceList'
import { Column } from 'shared/ui/Table/types'
import { useCallback, useMemo } from 'react'
import { SortableHeader } from '../utility/SortableHeader'
import { List } from 'infrastructure/api'
import { useNavigateTo } from 'infrastructure/routing'
import { useResourceRoutes } from '../../api/resourceRouting'
import { StringFilter } from './resourceList/StringFilter'
import { Add } from '@mui/icons-material'
import { deleteManyDemos } from 'providers/mutations'
import { SwitchFilter } from './resourceList/SwitchFilter'
import { convertExpirationDate } from 'components/utility/utils'
import { format } from 'date-fns'
import DemoReverseLookup from './demoEnvironment_components/DemoReverseLookup'

export function DemoEnvironmentList() {
  const columns = useDemoColumns()
  const onBulkDelete = useCallback((ids: (number | string)[]) => {
    return deleteManyDemos(ids as number[])
  }, [])
  return (
    <PaginatedResourceList
      title={'Demo Environments'}
      resourceKey={'demos'}
      columns={columns}
      header={<DemoFilters />}
      onBulkDelete={onBulkDelete}
    />
  )
}

export function useDemoColumns(): Column<List.Demo>[] {
  return useMemo(() => {
    return [
      {
        title: <SortableHeader title={'Demo Id'} id={'id'} />,
        width: 175,
        rowContent({ id }: List.Demo) {
          return id
        },
      },
      {
        title: <SortableHeader title={'School Name'} id={'school_name'} />,
        width: 400,
        rowContent({ school_name }: List.Demo) {
          return school_name
        },
      },
      {
        title: 'Type',
        width: 100,
        rowContent({ demo_type }: List.Demo) {
          if (demo_type === '') {
            return 'Teacher User Demo'
          }
          return demo_type
        },
      },
      {
        title: 'Date Created',
        width: 100,
        rowContent({ date_created }: List.Demo) {
          return format(new Date(date_created), 'yyyy-MM-dd')
        },
      },
      {
        title: 'Expiration Date',
        width: 100,
        rowContent({ expiration_date }: List.Demo) {
          return convertExpirationDate(expiration_date ?? '')
        },
      },
      {
        title: 'Kiddom Access',
        width: 100,
        rowContent({ date_deleted }: List.Demo) {
          let status = (
            <span style={{ color: 'green', textAlign: 'center' }}>Enabled</span>
          )
          if (date_deleted !== null) {
            status = (
              <span style={{ color: 'red', textAlign: 'center' }}>Deleted</span>
            )
          }
          return status
        },
      },
    ]
  }, [])
}

function DemoFilters() {
  const navigate = useNavigateTo()
  const { create } = useResourceRoutes('demos')
  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        <Box display="flex" alignItems="left" justifyContent="space-between">
          <StringFilter filterKey={'schoolName'} label={'School Name'} />
          <DemoReverseLookup />
        </Box>
        <SwitchFilter
          label="Include Soft Deleted"
          filterKey="includeSoftDeleted"
        />
      </Box>
      <Box>
        <Button
          variant="text"
          startIcon={<Add />}
          onClick={() => navigate(create)}
        >
          Create
        </Button>
      </Box>
    </Box>
  )
}
